import { render, staticRenderFns } from "./to-top.vue?vue&type=template&id=9078571a&scoped=true&"
import script from "./to-top.vue?vue&type=script&lang=js&"
export * from "./to-top.vue?vue&type=script&lang=js&"
import style0 from "./to-top.vue?vue&type=style&index=0&id=9078571a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9078571a",
  null
  
)

export default component.exports